

// import React, { useState, useEffect } from "react";
// import "./NewPatientRegistration.css";

// const InpatientManagement = ({ screenAction, triggerSave }) => {
//   const [isDisabled, setIsDisabled] = useState(true);
//   const [searchText, setSearchText] = useState("");
//   const [admissions, setAdmissions] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);

//   // Master Data Lists for Dropdowns
//   const [departments, setDepartments] = useState([]);
//   const [beds, setBeds] = useState([]);
//   const [doctors, setDoctors] = useState([]);
//   const [proceduresList, setProceduresList] = useState([]);
//   const [labTestsList, setLabTestsList] = useState([]); // NEW: For Lab Tests

//   // Format Helper for datetime-local inputs
//   const formatForInput = (isoString) => {
//     if (!isoString) return "";
//     return new Date(isoString).toISOString().slice(0, 16);
//   };

//   const initialFormState = {
//     admission_id: "",
//     patient_id: "",
//     patient_name: "",
//     admission_date: "",
//     reason_for_admission: "",
//     department: "",
//     consulting_doctor: "",
//     admission_type: "Planned",
//     referred_by: "",
//     bed_id: "",
//     room_no: "",
//     bed_no: "",
//     ward_type: "",
//     bed_charges: "",
//     primary_diagnosis: "",
//     secondary_diagnosis: "",
//     symptoms: "",
//     medical_history: "",
//     allergies: "",
//     treatment_plan: "",
//     status: "Admitted",
//     _isExisting: false,
    
//     // Patient Basic Details
//     patient_details: { age: "", gender: "", mobile: "", address: "", emergency_name: "", emergency_phone: "", blood_group: "" },

//     // Sub-Arrays
//     readings: [],
//     doctor_visits: [],
//     medications: [],
//     lab_tests: [], // Array for Lab Tests
//     procedures: []
//   };

//   const [formData, setFormData] = useState(initialFormState);
// const [suggestions, setSuggestions] = useState([]);


// // --- INITIAL MASTER DATA LOAD ---
//   useEffect(() => {
//     const fetchMasters = async () => {
//       const user = JSON.parse(localStorage.getItem("user"));
//       const empId = user?.id;
//       try {
//         const [deptRes, bedRes, docRes, procRes] = await Promise.all([
//           fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/departments?employee_id=${empId}`),
//           fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/beds?employee_id=${empId}`),
//           fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/doctors?employee_id=${empId}`),
//           fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/procedures?employee_id=${empId}`)
//         ]);
        
//         const deptData = await deptRes.json();
//         const bedData = await bedRes.json();
//         const docData = await docRes.json();
//         const procData = await procRes.json();

//         // SAFEGURAD: Ensure everything is an array before setting state!
//         setDepartments(Array.isArray(deptData) ? deptData : (deptData.data || []));
//         setBeds(Array.isArray(bedData) ? bedData : (bedData.data || []));
//         setDoctors(Array.isArray(docData) ? docData : (docData.data || []));
//         setProceduresList(Array.isArray(procData) ? procData : (procData.data || []));

//       } catch (err) {
//         console.error("Error loading master data", err);
//       }
//     };
//     fetchMasters();
//   }, []);


//   // --- FETCH SPECIFIC LAB TEST BY ID ---
//   const fetchTestDetails = async (testId, index) => {
//     if (!testId || testId.length < 3) return; // Don't fetch until they've typed at least something like "T10"
//     try {
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/ratecard/test/${testId}`);
//       if (res.ok) {
//         const data = await res.json();
//         if (data && data.test_name) {
//           updateArrayItem('lab_tests', index, 'test_name', data.test_name);
//         }
//       }
//     } catch (err) {
//       console.error("Error fetching test details");
//     }
//   };

//   const getNewAdmissionId = () => {
//     return `ADM-${new Date().getFullYear()}-${Math.floor(1000 + Math.random() * 9000)}`;
//   };

//   // --- SEARCH EXISTING ADMISSIONS ---
//   const searchAdmissions = async (text) => {
//     setSearchText(text);
//     if (text.length < 2) {
//       setAdmissions([]);
//       setShowDropdown(false);
//       return;
//     }
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/inpatient/search?q=${text}&employee_id=${user?.id}`);
//       setAdmissions(await res.json());
//       setShowDropdown(true);
//     } catch (err) { }
//   };

//   const selectAdmission = async (adm) => {
//     try {
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/inpatient/${adm.admission_id}`);
//       const fullData = await res.json();
      
//       const user = JSON.parse(localStorage.getItem("user"));
//       const patRes = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patient-id?patient_id=${adm.patient_id}&employee_id=${user?.id}`);
//       const patData = await patRes.json();

//       setFormData({
//         ...initialFormState,
//         ...fullData,
//         admission_date: formatForInput(fullData.admission_date),
//         patient_details: patData || initialFormState.patient_details,
//         _isExisting: true
//       });
      
//       setSearchText(`${adm.admission_id} | ${adm.patient_name}`);
//       setShowDropdown(false);
//       setIsDisabled(screenAction === "view");
//     } catch (err) {
//       console.error("Error loading full admission");
//     }
//   };


// const handlePatientSearch = async (e) => {
//   const val = e.target.value;

//   setFormData({ ...formData, patient_id: val });

//   if (val.length > 2) {
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));

//       const res = await fetch(
//         `https://hmsapi.emedhatechnologies.com/master/api/api/in-patient-search?search=${val}&employee_id=${user?.id}`
//       );

//       const data = await res.json();
//       setSuggestions(data || []);
//     } catch (err) {
//       console.error(err);
//     }
//   } else {
//     setSuggestions([]);
//   }
// };

// // const handleSelectPatient = (patient) => {
// //   setFormData((prev) => ({
// //     ...prev,
// //     patient_id: patient.patient_id,
// //     patient_name: patient.name,
// //     patient_details: patient,
// //     department: isPlanned ? (patient.department || "") : prev.department,
// //       consulting_doctor: isPlanned ? (patient.doctor || "") : prev.consulting_doctor,
// //   }));

// //   setSuggestions([]);
// // };


// const handleSelectPatient = (patient) => {
//   setFormData((prev) => {
//     const isPlanned = prev.admission_type === "Planned";
//     return {
//       ...prev,
//       patient_id: patient.patient_id,
//       patient_name: patient.name,
//       patient_details: patient,
//       // Auto-fill if 'Planned', otherwise leave as is
//       department: isPlanned ? (patient.department || "") : prev.department,
//       consulting_doctor: isPlanned ? (patient.doctor || "") : prev.consulting_doctor,
//     };
//   });

//   setSuggestions([]);
// };

//   // --- BED SELECTION AUTO-FILL ---
//   const handleBedSelect = (e) => {
//     const selectedBedId = e.target.value;
//     const bedInfo = beds.find(b => b.bed_id.toString() === selectedBedId);
    
//     if(bedInfo) {
//       setFormData(prev => ({
//         ...prev,
//         bed_id: bedInfo.bed_id,
//         room_no: bedInfo.room_no,
//         bed_no: bedInfo.bed_no,
//         ward_type: bedInfo.room_type,
//         bed_charges: bedInfo.rate
//       }));
//     } else {
//       setFormData(prev => ({ ...prev, bed_id: "", room_no: "", bed_no: "", ward_type: "", bed_charges: "" }));
//     }
//   };

//   // --- FORM ACTIONS ---
//   const clearForm = () => {
//     setFormData({ ...initialFormState, admission_id: getNewAdmissionId(), admission_date: formatForInput(new Date()) });
//     setSearchText("");
//     setIsDisabled(false);
//   };

//   useEffect(() => {
//     if (triggerSave > 0 && screenAction === "save") handleSubmit();
//   }, [triggerSave]);

//   useEffect(() => {
//     if (screenAction === "add") clearForm();
//     if (screenAction === "edit") setIsDisabled(false);
//     if (screenAction === "view") setIsDisabled(true);
//     if (screenAction === "refresh") clearForm();
//     if (screenAction === "print") printForm();
//   }, [screenAction]);

//   // const handleChange = (e) => {
//   //   setFormData({ ...formData, [e.target.name]: e.target.value });
//   // };


//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     // Intercept admission_type changes for auto-fill logic
//     if (name === "admission_type") {
//       if (value === "Planned") {
//         setFormData(prev => ({ 
//           ...prev, 
//           [name]: value,
//           // Auto-fill from the searched patient details
//           department: prev.patient_details?.department || "",
//           consulting_doctor: prev.patient_details?.doctor || ""
//         }));
//       } else {
//         setFormData(prev => ({ 
//           ...prev, 
//           [name]: value,
//           // Clear fields so user must manually select for Emergency/Transfer
//           department: "",
//           consulting_doctor: ""
//         }));
//       }
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };

//   // --- ARRAY MANAGEMENT HELPERS ---
//   const addToArray = (arrayName, defaultItem) => {
//     setFormData(prev => ({ ...prev, [arrayName]: [...prev[arrayName], defaultItem] }));
//   };
//   const updateArrayItem = (arrayName, index, field, value) => {
//     const newArray = [...formData[arrayName]];
//     newArray[index][field] = value;
//     setFormData({ ...formData, [arrayName]: newArray });
//   };
//   const removeFromArray = (arrayName, index) => {
//     const newArray = formData[arrayName].filter((_, i) => i !== index);
//     setFormData({ ...formData, [arrayName]: newArray });
//   };

//   // --- SAVE LOGIC ---
//   const handleSubmit = async () => {
//     if (!formData.patient_id || !formData.bed_id) {
//       return alert("Patient ID and Bed Selection are required!");
//     }
//     const user = JSON.parse(localStorage.getItem("user"));
//     const payload = { ...formData, created_by: user?.id };
//      delete payload._isExisting;


//     const method = formData._isExisting ? "PUT" : "POST";
//     const url = method === "POST" 
//       ? "https://hmsapi.emedhatechnologies.com/master/api/api/inpatient" 
//       : `https://hmsapi.emedhatechnologies.com/master/api/api/inpatient/${formData.admission_id}`;
    
//     try {
//       const res = await fetch(url, {
//         method: method,
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });
      
//       if (res.ok) {
//         alert(method === "POST" ? "Admission Record Created!" : "Admission Record Updated!");
//         if (method === "POST") clearForm(); 
//       } else {
//         alert("Error saving record.");
//       }
//     } catch (err) {
//       alert("Network error.");
//     }
//   };


// // --- PRINT FORM ---
//   const printForm = () => {
//     const newWindow = window.open("", "", "width=900,height=800");
//     const today = new Date().toLocaleDateString();
    
//     // Helper to render arrays cleanly
//     const renderTable = (headers, rows, emptyMessage) => {
//       if (rows.length === 0) return `<p style="font-size: 13px; color: #7f8c8d; font-style: italic;">${emptyMessage}</p>`;
//       return `
//         <table>
//           <thead>
//             <tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr>
//           </thead>
//           <tbody>
//             ${rows.join('')}
//           </tbody>
//         </table>
//       `;
//     };

//     const htmlContent = `
//       <html>
//         <head>
//           <title>Admission Face Sheet - ${formData.admission_id}</title>
//           <style>
//             body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
//             .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #2980b9; padding-bottom: 10px; margin-bottom: 20px; }
//             .hospital-info h1 { margin: 0; color: #2c3e50; font-size: 24px; text-transform: uppercase; }
//             .hospital-info p { margin: 2px 0; font-size: 12px; color: #7f8c8d; }
//             .report-title { text-align: right; }
//             .report-title h2 { margin: 0; color: #2980b9; font-size: 18px; }
//             .section-header { background: #ecf0f1; padding: 8px 12px; font-weight: bold; font-size: 14px; border-left: 4px solid #2980b9; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; }
//             .data-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 10px; }
//             .data-item { font-size: 13px; display: flex; border-bottom: 1px dotted #ccc; padding: 6px 0; }
//             .label { font-weight: 600; width: 160px; color: #555; }
//             .value { flex: 1; color: #000; font-weight: 500; }
//             .full-width { grid-column: span 2; }
            
//             /* Table Styles for Arrays */
//             table { width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 12px; }
//             th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
//             th { background-color: #f4f0fa; color: #333; font-weight: 600; }
            
//             .sig-box { margin-top: 60px; display: flex; justify-content: space-between; }
//             .sig { border-top: 1px solid #000; width: 200px; text-align: center; padding-top: 5px; font-size: 12px; }
//             .footer { margin-top: 40px; font-size: 10px; text-align: center; color: #95a5a6; border-top: 1px solid #eee; padding-top: 10px; }
//           </style>
//         </head>
//         <body onload="window.print(); window.close();">
          
//           <div class="header">
//             <div class="hospital-info">
//               <h1>EMEDHA CARE HOSPITAL</h1>
//               <p>Inpatient Admission Face Sheet</p>
//             </div>
//             <div class="report-title">
//               <h2>IPD ADMISSION RECORD</h2>
//               <p>Print Date: ${today}</p>
//             </div>
//           </div>

//           <div class="section-header">1. Patient Basic Details</div>
//           <div class="data-grid">
//             <div class="data-item"><span class="label">Patient ID:</span> <span class="value">${formData.patient_id}</span></div>
//             <div class="data-item"><span class="label">Full Name:</span> <span class="value">${formData.patient_name}</span></div>
//             <div class="data-item"><span class="label">Age / Gender:</span> <span class="value">${formData.patient_details?.age || 'N/A'} / ${formData.patient_details?.gender || 'N/A'}</span></div>
//             <div class="data-item"><span class="label">Blood Group:</span> <span class="value">${formData.patient_details?.blood_group || 'N/A'}</span></div>
//             <div class="data-item"><span class="label">Contact Number:</span> <span class="value">${formData.patient_details?.mobile || 'N/A'}</span></div>
//             <div class="data-item"><span class="label">Emergency Contact:</span> <span class="value">${formData.patient_details?.emergency_name || ''} (${formData.patient_details?.emergency_phone || ''})</span></div>
//             <div class="data-item full-width"><span class="label">Address:</span> <span class="value">${formData.patient_details?.address || 'N/A'}</span></div>
//           </div>

//           <div class="section-header">2. Admission & Ward Details</div>
//           <div class="data-grid">
//             <div class="data-item"><span class="label">Admission ID:</span> <span class="value">${formData.admission_id}</span></div>
//             <div class="data-item"><span class="label">Date & Time:</span> <span class="value">${formData.admission_date ? new Date(formData.admission_date).toLocaleString() : 'N/A'}</span></div>
//             <div class="data-item"><span class="label">Department:</span> <span class="value">${formData.department || 'N/A'}</span></div>
//             <div class="data-item"><span class="label">Consulting Doctor:</span> <span class="value">${formData.consulting_doctor || 'N/A'}</span></div>
//             <div class="data-item"><span class="label">Admission Type:</span> <span class="value">${formData.admission_type}</span></div>
//             <div class="data-item"><span class="label">Ward / Room / Bed:</span> <span class="value">${formData.ward_type || 'N/A'} / ${formData.room_no || 'N/A'} / ${formData.bed_no || 'N/A'}</span></div>
//             <div class="data-item full-width"><span class="label">Reason for Admission:</span> <span class="value">${formData.reason_for_admission || 'N/A'}</span></div>
//           </div>

//           <div class="section-header">3. Clinical Overview</div>
//           <div class="data-grid">
//             <div class="data-item"><span class="label">Primary Diagnosis:</span> <span class="value">${formData.primary_diagnosis || 'N/A'}</span></div>
//             <div class="data-item"><span class="label">Secondary Diagnosis:</span> <span class="value">${formData.secondary_diagnosis || 'N/A'}</span></div>
//             <div class="data-item full-width"><span class="label">Allergies:</span> <span class="value" style="color: red; font-weight: bold;">${formData.allergies || 'None Recorded'}</span></div>
//           </div>

//           <div class="section-header">4. Clinical Records</div>
          
//           <h4 style="margin: 10px 0 5px 0; color: #555;">Vitals & Readings</h4>
//           ${renderTable(
//             ['Time', 'Temp (°F)', 'BP (mmHg)', 'Pulse', 'SpO2 (%)'],
//             formData.readings.map(r => `<tr><td>${new Date(r.reading_time).toLocaleString()}</td><td>${r.temperature || '-'}</td><td>${r.blood_pressure || '-'}</td><td>${r.pulse || '-'}</td><td>${r.oxygen_saturation || '-'}</td></tr>`),
//             'No vitals recorded.'
//           )}

//           <h4 style="margin: 10px 0 5px 0; color: #555;">Doctor Visits</h4>
//           ${renderTable(
//             ['Time', 'Doctor Code', 'Notes', 'Instructions'],
//             formData.doctor_visits.map(v => `<tr><td>${new Date(v.visit_time).toLocaleString()}</td><td>${v.doc_cd || '-'}</td><td>${v.notes || '-'}</td><td>${v.instructions || '-'}</td></tr>`),
//             'No doctor visits recorded.'
//           )}

//           <h4 style="margin: 10px 0 5px 0; color: #555;">Medications</h4>
//           ${renderTable(
//             ['Drug Name', 'Dosage', 'Route', 'Start Date', 'End Date'],
//             formData.medications.map(m => `<tr><td>${m.drug_name || '-'}</td><td>${m.dosage || '-'}</td><td>${m.route || '-'}</td><td>${m.start_date ? m.start_date.split('T')[0] : '-'}</td><td>${m.end_date ? m.end_date.split('T')[0] : '-'}</td></tr>`),
//             'No medications prescribed.'
//           )}

//           <h4 style="margin: 10px 0 5px 0; color: #555;">Lab & Diagnostics</h4>
//           ${renderTable(
//             ['Order Time', 'Test Name', 'Status', 'Result'],
//             formData.lab_tests.map(l => `<tr><td>${new Date(l.order_time).toLocaleString()}</td><td>${l.test_name || '-'}</td><td>${l.status || '-'}</td><td>${l.result || '-'}</td></tr>`),
//             'No lab tests ordered.'
//           )}

//           <h4 style="margin: 10px 0 5px 0; color: #555;">Procedures / Surgeries</h4>
//           ${renderTable(
//             ['Procedure', 'Date & Time', 'Location', 'Status'],
//             formData.procedures.map(p => `<tr><td>${p.proc_name || '-'}</td><td>${new Date(p.surgery_date).toLocaleString()}</td><td>${p.location || '-'}</td><td>${p.status || '-'}</td></tr>`),
//             'No procedures scheduled.'
//           )}

//           <div class="sig-box">
//              <div class="sig">Patient / Guardian Signature</div>
//              <div class="sig">Admitting Officer</div>
//           </div>

//           <div class="footer">
//             System Generated Report - Emedha HMS
//           </div>
//         </body>
//       </html>
//     `;
    
//     newWindow.document.write(htmlContent);
//     newWindow.document.close();
//   };

 




//   // --- REUSABLE STYLES FOR COOL BUTTONS ---
//   const addBtnStyle = { padding: '6px 14px', backgroundColor: '#3498db', color: '#fff', border: 'none', borderRadius: '20px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold', boxShadow: '0 2px 5px rgba(52, 152, 219, 0.3)', transition: 'all 0.2s ease', alignSelf: 'center' };
//   const removeBtnStyle = { width: '28px', height: '28px', backgroundColor: '#ffebeb', color: '#e74c3c', border: '1px solid #f5c6c6', borderRadius: '50%', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s ease', marginLeft: 'auto' };

//   return (
//     <div className="registration-container fade-in">
      
//       {(screenAction === "edit" || screenAction === "view") && (
//         <div className="patient-search">
//           <label>Search Admissions</label>
//           <input type="text" value={searchText} placeholder="Search by Admission ID, Patient ID, Mobile..." onChange={(e) => searchAdmissions(e.target.value)} autoFocus />
//           {showDropdown && admissions.length > 0 && (
//             <div className="patient-dropdown">
//               {admissions.map((adm) => (
//                 <div key={adm.admission_id} className="patient-item" onClick={() => selectAdmission(adm)}>
//                   {adm.admission_id} | {adm.patient_name} | Ph: {adm.mobile}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       )}

//       <form className="luxury-form">
        
//         {/* 1. PATIENT BASIC DETAILS */}
//         <div className="form-section-header"><h3>1. Patient Basic Details</h3></div>
//         <div className="form-grid">
// <div className="input-box">
//   <label>
//     Patient ID / Name / Mobile <span style={{ color: "red" }}>*</span>
//   </label>

//   <input
//     type="text"
//     value={formData.patient_id}
//     onChange={handlePatientSearch}
//     placeholder="Search by ID, Name, Mobile..."
//   />

//   {suggestions.length > 0 && (
//     <div className="dropdown">
//       {suggestions.map((item, index) => (
//         <div
//           key={index}
//           className="dropdown-item"
//           onClick={() => handleSelectPatient(item)}
//         >
//           <strong>{item.patient_id}</strong> - {item.name} ({item.mobile})
//         </div>
//       ))}
//     </div>
//   )}
// </div>
//           <div className="input-box read-only"><label>Full Name</label><input type="text" value={formData.patient_name} readOnly /></div>
//           <div className="input-box read-only"><label>Age / Gender</label><input type="text" value={`${formData.patient_details?.age || ''} / ${formData.patient_details?.gender || ''}`} readOnly /></div>
//           <div className="input-box read-only"><label>Blood Group</label><input type="text" value={formData.patient_details?.blood_group || ''} readOnly /></div>
//           <div className="input-box read-only"><label>Contact Number</label><input type="text" value={formData.patient_details?.mobile || ''} readOnly /></div>
//           <div className="input-box read-only"><label>Emergency Contact</label><input type="text" value={`${formData.patient_details?.emergency_name || ''} - ${formData.patient_details?.emergency_phone || ''}`} readOnly /></div>
//           <div className="input-box read-only full-width"><label>Address</label><input type="text" value={formData.patient_details?.address || ''} readOnly /></div>
//         </div>

//         {/* 2. ADMISSION DETAILS */}
//         <div className="form-section-header"><h3>2. Admission Details</h3></div>
//         <div className="form-grid">
//           <div className="input-box read-only"><label>Admission ID</label><input type="text" value={formData.admission_id} readOnly /></div>
//           <div className="input-box"><label>Admission Date & Time</label><input type="datetime-local" name="admission_date" value={formData.admission_date} onChange={handleChange} disabled={isDisabled} /></div>
//            <div className="input-box"><label>Admission Type</label>
//             <select name="admission_type" value={formData.admission_type} onChange={handleChange} disabled={isDisabled}>
//               <option>Planned</option><option>Emergency</option><option>Transfer</option>
//             </select>
//           </div>
//           <div className="input-box"><label>Department</label>
//             <select name="department" value={formData.department} onChange={handleChange} disabled={isDisabled}>
//               <option value="">Select Dept</option>
//               {departments.map(d => <option key={d.dept_cd} value={d.dept_name}>{d.dept_name}</option>)}
//             </select>
//           </div>
//           <div className="input-box"><label>Consulting Doctor</label>
//             <select name="consulting_doctor" value={formData.consulting_doctor} onChange={handleChange} disabled={isDisabled}>
//               <option value="">Select Doctor</option>
//               {doctors.map(d => <option key={d.doc_cd} value={d.doctor_name}>{d.doctor_name}</option>)}
//             </select>
//           </div>
        
//           <div className="input-box"><label>Referred By</label><input type="text" name="referred_by" value={formData.referred_by} onChange={handleChange} disabled={isDisabled} /></div>
//           <div className="input-box full-width"><label>Reason for Admission</label><input type="text" name="reason_for_admission" value={formData.reason_for_admission} onChange={handleChange} disabled={isDisabled} /></div>
//         </div>

//         {/* 3. BED / WARD MANAGEMENT */}
//         <div className="form-section-header"><h3>3. Bed / Ward Management</h3></div>
//         <div className="form-grid">
//           <div className="input-box"><label>Assign Bed <span style={{color:'red'}}>*</span></label>
//             <select name="bed_id" value={formData.bed_id} onChange={handleBedSelect} disabled={isDisabled}>
//               <option value="">-- Available Beds --</option>
//               {beds.filter(b => b.status === "Available" || b.bed_id === formData.bed_id).map(b => (
//                 <option key={b.bed_id} value={b.bed_id}>Room: {b.room_no} | Bed: {b.bed_no} ({b.room_type})</option>
//               ))}
//             </select>
//           </div>
//           <div className="input-box read-only"><label>Ward Type</label><input type="text" value={formData.ward_type} readOnly /></div>
//           <div className="input-box read-only"><label>Room No.</label><input type="text" value={formData.room_no} readOnly /></div>
//           <div className="input-box read-only"><label>Bed No.</label><input type="text" value={formData.bed_no} readOnly /></div>
//           <div className="input-box read-only"><label>Bed Charges (Per Day)</label><input type="text" value={formData.bed_charges} readOnly /></div>
//         </div>

//         {/* 4. CLINICAL INFORMATION */}
//         <div className="form-section-header"><h3>4. Clinical Information (Joining Time)</h3></div>
//         <div className="form-grid">
//           <div className="input-box"><label>Primary Diagnosis</label><input type="text" name="primary_diagnosis" value={formData.primary_diagnosis} onChange={handleChange} disabled={isDisabled} /></div>
//           <div className="input-box"><label>Secondary Diagnosis</label><input type="text" name="secondary_diagnosis" value={formData.secondary_diagnosis} onChange={handleChange} disabled={isDisabled} /></div>
//           <div className="input-box full-width"><label>Symptoms</label><input type="text" name="symptoms" value={formData.symptoms} onChange={handleChange} disabled={isDisabled} /></div>
//           <div className="input-box"><label>Medical History</label><input type="text" name="medical_history" value={formData.medical_history} onChange={handleChange} disabled={isDisabled} /></div>
//           <div className="input-box"><label>Allergies <span style={{color:'red'}}>(CRITICAL)</span></label><input type="text" name="allergies" value={formData.allergies} onChange={handleChange} disabled={isDisabled} style={{border:'1px solid red'}}/></div>
//           <div className="input-box full-width"><label>Treatment Plan</label><input type="text" name="treatment_plan" value={formData.treatment_plan} onChange={handleChange} disabled={isDisabled} /></div>
//         </div>

//         {/* --- DYNAMIC ARRAYS (Readings, Visits, Meds, Labs, Procs) --- */}
        
//         {/* Readings */}
//         <div className="form-section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <h3>Vitals & Readings</h3>
//           {!isDisabled && <button type="button" style={addBtnStyle} onClick={() => addToArray('readings', { reading_time: formatForInput(new Date()), temperature: '', blood_pressure: '', pulse: '', oxygen_saturation: '' })}>+ Add Reading</button>}
//         </div>
//         {formData.readings.map((item, idx) => (
//           <div key={idx} className="form-grid" style={{ background: '#f4f4f4', padding: '12px', marginBottom: '8px', borderRadius: '8px', alignItems: 'center', position: 'relative' }}>
//             <div className="input-box"><label>Time</label><input type="datetime-local" value={formatForInput(item.reading_time)} onChange={(e) => updateArrayItem('readings', idx, 'reading_time', e.target.value)} disabled={isDisabled} /></div>
//             <div className="input-box"><label>Temp (°F)</label><input type="text" value={item.temperature} onChange={(e) => updateArrayItem('readings', idx, 'temperature', e.target.value)} disabled={isDisabled} /></div>
//             <div className="input-box"><label>BP (mmHg)</label><input type="text" value={item.blood_pressure} onChange={(e) => updateArrayItem('readings', idx, 'blood_pressure', e.target.value)} disabled={isDisabled} /></div>
//             <div className="input-box"><label>Pulse</label><input type="text" value={item.pulse} onChange={(e) => updateArrayItem('readings', idx, 'pulse', e.target.value)} disabled={isDisabled} /></div>
//             <div className="input-box"><label>SpO2 (%)</label><input type="text" value={item.oxygen_saturation} onChange={(e) => updateArrayItem('readings', idx, 'oxygen_saturation', e.target.value)} disabled={isDisabled} /></div>
//             {!isDisabled && <div style={{ display: 'flex', alignItems: 'center', height: '100%', paddingLeft: '10px' }}><button type="button" style={removeBtnStyle} onClick={() => removeFromArray('readings', idx)} title="Remove">✕</button></div>}
//           </div>
//         ))}

//         {/* Doctor Visits */}
//         <div className="form-section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
//           <h3>Doctor Visits</h3>
//           {!isDisabled && <button type="button" style={addBtnStyle} onClick={() => addToArray('doctor_visits', { visit_time: formatForInput(new Date()), doc_cd: '', notes: '', instructions: '' })}>+ Add Visit</button>}
//         </div>
//         {formData.doctor_visits.map((item, idx) => (
//           <div key={idx} className="form-grid" style={{ background: '#eef6fc', padding: '12px', marginBottom: '8px', borderRadius: '8px', alignItems: 'center', position: 'relative' }}>
//             <div className="input-box"><label>Time</label><input type="datetime-local" value={formatForInput(item.visit_time)} onChange={(e) => updateArrayItem('doctor_visits', idx, 'visit_time', e.target.value)} disabled={isDisabled} /></div>
//             <div className="input-box"><label>Doctor</label>
//               <select value={item.doc_cd} onChange={(e) => updateArrayItem('doctor_visits', idx, 'doc_cd', e.target.value)} disabled={isDisabled}>
//                 <option value="">Select</option>
//                 {doctors.map(d => <option key={d.doc_cd} value={d.doc_cd}>{d.doctor_name}</option>)}
//               </select>
//             </div>
//             <div className="input-box"><label>Notes</label><input type="text" value={item.notes} onChange={(e) => updateArrayItem('doctor_visits', idx, 'notes', e.target.value)} disabled={isDisabled} /></div>
//             <div className="input-box"><label>Instructions</label><input type="text" value={item.instructions} onChange={(e) => updateArrayItem('doctor_visits', idx, 'instructions', e.target.value)} disabled={isDisabled} /></div>
//             {!isDisabled && <div style={{ display: 'flex', alignItems: 'center', height: '100%', paddingLeft: '10px' }}><button type="button" style={removeBtnStyle} onClick={() => removeFromArray('doctor_visits', idx)} title="Remove">✕</button></div>}
//           </div>
//         ))}

//         {/* Medications */}
//         <div className="form-section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
//           <h3>Medications & Prescriptions</h3>
//           {!isDisabled && <button type="button" style={addBtnStyle} onClick={() => addToArray('medications', { drug_name: '', dosage: '', route: 'Oral', start_date: '', end_date: '' })}>+ Add Med</button>}
//         </div>
//         {formData.medications.map((item, idx) => (
//           <div key={idx} className="form-grid" style={{ background: '#fdf2e9', padding: '12px', marginBottom: '8px', borderRadius: '8px', alignItems: 'center', position: 'relative' }}>
//             <div className="input-box"><label>Drug Name</label><input type="text" value={item.drug_name} onChange={(e) => updateArrayItem('medications', idx, 'drug_name', e.target.value)} disabled={isDisabled} /></div>
//             <div className="input-box"><label>Dosage</label><input type="text" value={item.dosage} onChange={(e) => updateArrayItem('medications', idx, 'dosage', e.target.value)} disabled={isDisabled} placeholder="e.g., 1-0-1" /></div>
//             <div className="input-box"><label>Route</label>
//               <select value={item.route} onChange={(e) => updateArrayItem('medications', idx, 'route', e.target.value)} disabled={isDisabled}>
//                 <option>Oral</option><option>IV</option><option>Injection</option><option>Topical</option>
//               </select>
//             </div>
//             <div className="input-box"><label>Start</label><input type="date" value={item.start_date ? item.start_date.split("T")[0] : ""} onChange={(e) => updateArrayItem('medications', idx, 'start_date', e.target.value)} disabled={isDisabled} /></div>
//             <div className="input-box"><label>End</label><input type="date" value={item.end_date ? item.end_date.split("T")[0] : ""} onChange={(e) => updateArrayItem('medications', idx, 'end_date', e.target.value)} disabled={isDisabled} /></div>
//             {!isDisabled && <div style={{ display: 'flex', alignItems: 'center', height: '100%', paddingLeft: '10px' }}><button type="button" style={removeBtnStyle} onClick={() => removeFromArray('medications', idx)} title="Remove">✕</button></div>}
//           </div>
//         ))}

  
//     {/* LAB TESTS (UPDATED FOR INDIVIDUAL ID FETCH) */}
//         <div className="form-section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
//           <h3>Lab & Diagnostics</h3>
//           {!isDisabled && <button type="button" style={addBtnStyle} onClick={() => addToArray('lab_tests', { order_time: formatForInput(new Date()), test_id: '', test_name: '', ordered_by: '', result: '', status: 'Pending' })}>+ Add Lab Test</button>}
//         </div>
//         {formData.lab_tests.map((item, idx) => (
//           <div key={idx} className="form-grid" style={{ background: '#f5eeff', padding: '12px', marginBottom: '8px', borderRadius: '8px', alignItems: 'center', position: 'relative' }}>
//             <div className="input-box">
//               <label>Order Time</label>
//               <input type="datetime-local" value={formatForInput(item.order_time)} onChange={(e) => updateArrayItem('lab_tests', idx, 'order_time', e.target.value)} disabled={isDisabled} />
//             </div>
            
//             <div className="input-box">
//               <label>Test ID</label>
//               <input 
//                 type="text" 
//                 value={item.test_id} 
//                 placeholder="e.g. T1001"
//                 disabled={isDisabled}
//                 onChange={(e) => {
//                   const val = e.target.value;
//                   updateArrayItem('lab_tests', idx, 'test_id', val);
//                   fetchTestDetails(val, idx); // Trigger the fetch API!
//                 }} 
//               />
//             </div>
            
//             <div className="input-box read-only">
//               <label>Test Name</label>
//               <input type="text" value={item.test_name} readOnly placeholder="Auto-fills..." />
//             </div>

//             <div className="input-box">
//               <label>Ordered By</label>
//               <select value={item.ordered_by} onChange={(e) => updateArrayItem('lab_tests', idx, 'ordered_by', e.target.value)} disabled={isDisabled}>
//                 <option value="">Select Doctor</option>
//                 {doctors.map(d => <option key={d.doc_cd} value={d.doctor_name}>{d.doctor_name}</option>)}
//               </select>
//             </div>
            
//             <div className="input-box">
//               <label>Result</label>
//               <input type="text" value={item.result} onChange={(e) => updateArrayItem('lab_tests', idx, 'result', e.target.value)} disabled={isDisabled} placeholder="If completed..." />
//             </div>
            
//             <div className="input-box">
//               <label>Status</label>
//               <select value={item.status} onChange={(e) => updateArrayItem('lab_tests', idx, 'status', e.target.value)} disabled={isDisabled}>
//                 <option>Pending</option><option>Completed</option><option>Cancelled</option>
//               </select>
//             </div>
            
//             {!isDisabled && <div style={{ display: 'flex', alignItems: 'center', height: '100%', paddingLeft: '10px' }}><button type="button" style={removeBtnStyle} onClick={() => removeFromArray('lab_tests', idx)} title="Remove">✕</button></div>}
//           </div>
//         ))}
//         {/* Procedures */}
//         <div className="form-section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
//           <h3>Procedures / Surgeries</h3>
//           {!isDisabled && <button type="button" style={addBtnStyle} onClick={() => addToArray('procedures', { proc_id: '', proc_name: '', surgery_date: formatForInput(new Date()), location: '', status: 'Scheduled' })}>+ Add Surgery</button>}
//         </div>
//         {formData.procedures.map((item, idx) => (
//           <div key={idx} className="form-grid" style={{ background: '#e8f8f5', padding: '12px', marginBottom: '8px', borderRadius: '8px', alignItems: 'center', position: 'relative' }}>
//             <div className="input-box"><label>Procedure</label>
//               <select value={item.proc_id} onChange={(e) => {
//                 const p = proceduresList.find(x => x.proc_id.toString() === e.target.value);
//                 updateArrayItem('procedures', idx, 'proc_id', e.target.value);
//                 updateArrayItem('procedures', idx, 'proc_name', p ? p.proc_name : '');
//                 updateArrayItem('procedures', idx, 'location', p ? p.surgery_location : '');
//               }} disabled={isDisabled}>
//                 <option value="">Select</option>
//                 {proceduresList.map(p => <option key={p.proc_id} value={p.proc_id}>{p.proc_name}</option>)}
//               </select>
//             </div>
//             <div className="input-box"><label>Date & Time</label><input type="datetime-local" value={formatForInput(item.surgery_date)} onChange={(e) => updateArrayItem('procedures', idx, 'surgery_date', e.target.value)} disabled={isDisabled} /></div>
//             <div className="input-box"><label>Location</label><input type="text" value={item.location} onChange={(e) => updateArrayItem('procedures', idx, 'location', e.target.value)} disabled={isDisabled} /></div>
//             <div className="input-box"><label>Status</label>
//               <select value={item.status} onChange={(e) => updateArrayItem('procedures', idx, 'status', e.target.value)} disabled={isDisabled}>
//                 <option>Scheduled</option><option>In Progress</option><option>Completed</option>
//               </select>
//             </div>
//             {!isDisabled && <div style={{ display: 'flex', alignItems: 'center', height: '100%', paddingLeft: '10px' }}><button type="button" style={removeBtnStyle} onClick={() => removeFromArray('procedures', idx)} title="Remove">✕</button></div>}
//           </div>
//         ))}

//       </form>
//     </div>
//   );
// };

// export default InpatientManagement;




import React, { useState, useEffect } from "react";
import "./NewPatientRegistration.css";

const InpatientManagement = ({ screenAction, triggerSave }) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [admissions, setAdmissions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  // Master Data Lists for Dropdowns
  const [departments, setDepartments] = useState([]);
  const [beds, setBeds] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [insuranceTypes, setInsuranceTypes] = useState([]); // NEW: Insurance Types

  // Format Helper for datetime-local inputs
  const formatForInput = (isoString) => {
    if (!isoString) return "";
    return new Date(isoString).toISOString().slice(0, 16);
  };

  const initialFormState = {
    admission_id: "",
    patient_id: "",
    patient_name: "",
    admission_date: "",
    reason_for_admission: "",
    department: "",
    consulting_doctor: "",
    admission_type: "Planned",
    referred_by: "",
    bed_id: "",
    room_no: "",
    bed_no: "",
    ward_type: "",
    bed_charges: "",
    primary_diagnosis: "",
    secondary_diagnosis: "",
    symptoms: "",
    medical_history: "",
    allergies: "",
    treatment_plan: "",
    status: "Admitted",
    
    // NEW: Insurance Fields
    insurance_type: "",
    insurance_company: "",
    policy_number: "",
    insurance_expiry_date: "",
    insurance_amount: "",

    _isExisting: false,
    patient_details: { age: "", gender: "", mobile: "", address: "", emergency_name: "", emergency_phone: "", blood_group: "" }
  };

  const [formData, setFormData] = useState(initialFormState);
  const [suggestions, setSuggestions] = useState([]);



  // --- RESPONSIVE INLINE STYLE HELPERS ---
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Helper to generate dynamic grid columns based on screen size
  const getGridStyle = (desktopCols) => ({
    display: "grid",
    gap: "15px",
    gridTemplateColumns: windowWidth >= 1024 ? `repeat(${desktopCols}, 1fr)` : windowWidth >= 768 ? "repeat(2, 1fr)" : "1fr"
  });

  // Helper to make specific inputs span multiple columns on desktop
  const getSpanStyle = (span) => ({
    gridColumn: windowWidth >= 1024 ? `span ${span}` : "auto"
  });

  // --- INITIAL MASTER DATA LOAD ---
  useEffect(() => {
    const fetchMasters = async () => {
      const user = JSON.parse(localStorage.getItem("user"));
      const empId = user?.id;
      try {
        const [deptRes, bedRes, docRes, insRes] = await Promise.all([
          fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/departments?employee_id=${empId}`),
          fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/beds?employee_id=${empId}`),
          fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/doctors?employee_id=${empId}`),
          fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/insurance-types?employee_id=${empId}`) // Fetch Insurance
        ]);
        
        const deptData = await deptRes.json();
        const bedData = await bedRes.json();
        const docData = await docRes.json();
        const insData = await insRes.json();

        setDepartments(Array.isArray(deptData) ? deptData : (deptData.data || []));
        setBeds(Array.isArray(bedData) ? bedData : (bedData.data || []));
        setDoctors(Array.isArray(docData) ? docData : (docData.data || []));
        setInsuranceTypes(Array.isArray(insData) ? insData.filter(i => i.status === "Active") : []);

      } catch (err) {
        console.error("Error loading master data", err);
      }
    };
    fetchMasters();
  }, []);



  const getNewAdmissionId = () => {
    return `ADM-${new Date().getFullYear()}-${Math.floor(1000 + Math.random() * 9000)}`;
  };

  // --- SEARCH EXISTING ADMISSIONS ---
  const searchAdmissions = async (text) => {
    setSearchText(text);
    if (text.length < 2) {
      setAdmissions([]);
      setShowDropdown(false);
      return;
    }
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/inpatient/search?q=${text}&employee_id=${user?.id}`);
      setAdmissions(await res.json());
      setShowDropdown(true);
    } catch (err) { }
  };

  const selectAdmission = async (adm) => {
    try {
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/inpatient/${adm.admission_id}`);
      const fullData = await res.json();
      
      const user = JSON.parse(localStorage.getItem("user"));
      const patRes = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patient-id?patient_id=${adm.patient_id}&employee_id=${user?.id}`);
      const patData = await patRes.json();

      setFormData({
        ...initialFormState,
        ...fullData,
        admission_date: formatForInput(fullData.admission_date),
        patient_details: patData || initialFormState.patient_details,
        _isExisting: true
      });
      
      setSearchText(`${adm.admission_id} | ${adm.patient_name}`);
      setShowDropdown(false);
      setIsDisabled(screenAction === "view");
    } catch (err) {
      console.error("Error loading full admission");
    }
  };


const handlePatientSearch = async (e) => {
  const val = e.target.value;

  setFormData({ ...formData, patient_id: val });

  if (val.length > 2) {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const res = await fetch(
        `https://hmsapi.emedhatechnologies.com/master/api/api/in-patient-search?search=${val}&employee_id=${user?.id}`
      );

      const data = await res.json();
      setSuggestions(data || []);
    } catch (err) {
      console.error(err);
    }
  } else {
    setSuggestions([]);
  }
};



const handleSelectPatient = (patient) => {
  setFormData((prev) => {
    const isPlanned = prev.admission_type === "Planned";
    return {
      ...prev,
      patient_id: patient.patient_id,
      patient_name: patient.name,
      patient_details: patient,
      // Auto-fill if 'Planned', otherwise leave as is
      department: isPlanned ? (patient.department || "") : prev.department,
      consulting_doctor: isPlanned ? (patient.doctor || "") : prev.consulting_doctor,
    };
  });

  setSuggestions([]);
};

  // --- BED SELECTION AUTO-FILL ---
  const handleBedSelect = (e) => {
    const selectedBedId = e.target.value;
    const bedInfo = beds.find(b => b.bed_id.toString() === selectedBedId);
    
    if(bedInfo) {
      setFormData(prev => ({
        ...prev,
        bed_id: bedInfo.bed_id,
        room_no: bedInfo.room_no,
        bed_no: bedInfo.bed_no,
        ward_type: bedInfo.room_type,
        bed_charges: bedInfo.rate
      }));
    } else {
      setFormData(prev => ({ ...prev, bed_id: "", room_no: "", bed_no: "", ward_type: "", bed_charges: "" }));
    }
  };

  // --- FORM ACTIONS ---
  const clearForm = () => {
    setFormData({ ...initialFormState, admission_id: getNewAdmissionId(), admission_date: formatForInput(new Date()) });
    setSearchText("");
    setIsDisabled(false);
  };

  useEffect(() => {
    if (triggerSave > 0 && screenAction === "save") handleSubmit();
  }, [triggerSave]);

  useEffect(() => {
    if (screenAction === "add") clearForm();
    if (screenAction === "edit") setIsDisabled(false);
    if (screenAction === "view") setIsDisabled(true);
    if (screenAction === "refresh") clearForm();
    if (screenAction === "print") printForm();
  }, [screenAction]);

  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };


  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Intercept admission_type changes for auto-fill logic
    if (name === "admission_type") {
      if (value === "Planned") {
        setFormData(prev => ({ 
          ...prev, 
          [name]: value,
          // Auto-fill from the searched patient details
          department: prev.patient_details?.department || "",
          consulting_doctor: prev.patient_details?.doctor || ""
        }));
      } else {
        setFormData(prev => ({ 
          ...prev, 
          [name]: value,
          // Clear fields so user must manually select for Emergency/Transfer
          department: "",
          consulting_doctor: ""
        }));
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };


  // --- SAVE LOGIC ---
  const handleSubmit = async () => {
    if (!formData.patient_id || !formData.bed_id) {
      return alert("Patient ID and Bed Selection are required!");
    }
    const user = JSON.parse(localStorage.getItem("user"));
    const payload = { ...formData, created_by: user?.id };
     delete payload._isExisting;


    const method = formData._isExisting ? "PUT" : "POST";
    const url = method === "POST" 
      ? "https://hmsapi.emedhatechnologies.com/master/api/api/inpatient" 
      : `https://hmsapi.emedhatechnologies.com/master/api/api/inpatient/${formData.admission_id}`;
    
    try {
      const res = await fetch(url, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      
      if (res.ok) {
        alert(method === "POST" ? "Admission Record Created!" : "Admission Record Updated!");
        if (method === "POST") clearForm(); 
      } else {
        alert("Error saving record.");
      }
    } catch (err) {
      alert("Network error.");
    }
  };


// --- PRINT FORM ---
  const printForm = () => {
    const newWindow = window.open("", "", "width=900,height=800");
    const today = new Date().toLocaleDateString();
    
    // Helper to render arrays cleanly
    const renderTable = (headers, rows, emptyMessage) => {
      if (rows.length === 0) return `<p style="font-size: 13px; color: #7f8c8d; font-style: italic;">${emptyMessage}</p>`;
      return `
        <table>
          <thead>
            <tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr>
          </thead>
          <tbody>
            ${rows.join('')}
          </tbody>
        </table>
      `;
    };
const htmlContent = `
      <html>
        <head>
          <title>Admission Face Sheet - ${formData.admission_id}</title>
          <style>
            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
            .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #2980b9; padding-bottom: 10px; margin-bottom: 20px; }
            .hospital-info h1 { margin: 0; color: #2c3e50; font-size: 24px; text-transform: uppercase; }
            .hospital-info p { margin: 2px 0; font-size: 12px; color: #7f8c8d; }
            .report-title { text-align: right; }
            .report-title h2 { margin: 0; color: #2980b9; font-size: 18px; }
            .section-header { background: #ecf0f1; padding: 8px 12px; font-weight: bold; font-size: 14px; border-left: 4px solid #2980b9; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; }
            .data-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 10px; }
            .data-item { font-size: 13px; display: flex; border-bottom: 1px dotted #ccc; padding: 6px 0; }
            .label { font-weight: 600; width: 160px; color: #555; }
            .value { flex: 1; color: #000; font-weight: 500; }
            .full-width { grid-column: span 2; }
            .sig-box { margin-top: 60px; display: flex; justify-content: space-between; }
            .sig { border-top: 1px solid #000; width: 200px; text-align: center; padding-top: 5px; font-size: 12px; }
            .footer { margin-top: 40px; font-size: 10px; text-align: center; color: #95a5a6; border-top: 1px solid #eee; padding-top: 10px; }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          
          <div class="header">
            <div class="hospital-info">
              <h1>EMEDHA CARE HOSPITAL</h1>
              <p>Inpatient Admission Face Sheet</p>
            </div>
            <div class="report-title">
              <h2>IPD ADMISSION RECORD</h2>
              <p>Print Date: ${today}</p>
            </div>
          </div>

          <div class="section-header">1. Patient Basic Details</div>
          <div class="data-grid">
            <div class="data-item"><span class="label">Patient ID:</span> <span class="value">${formData.patient_id}</span></div>
            <div class="data-item"><span class="label">Full Name:</span> <span class="value">${formData.patient_name}</span></div>
            <div class="data-item"><span class="label">Age / Gender:</span> <span class="value">${formData.patient_details?.age || 'N/A'} / ${formData.patient_details?.gender || 'N/A'}</span></div>
            <div class="data-item"><span class="label">Blood Group:</span> <span class="value">${formData.patient_details?.blood_group || 'N/A'}</span></div>
            <div class="data-item"><span class="label">Contact Number:</span> <span class="value">${formData.patient_details?.mobile || 'N/A'}</span></div>
            <div class="data-item"><span class="label">Emergency Contact:</span> <span class="value">${formData.patient_details?.emergency_name || ''} (${formData.patient_details?.emergency_phone || ''})</span></div>
            <div class="data-item full-width"><span class="label">Address:</span> <span class="value">${formData.patient_details?.address || 'N/A'}</span></div>
          </div>

          <div class="section-header">2. Admission & Ward Details</div>
          <div class="data-grid">
            <div class="data-item"><span class="label">Admission ID:</span> <span class="value">${formData.admission_id}</span></div>
            <div class="data-item"><span class="label">Date & Time:</span> <span class="value">${formData.admission_date ? new Date(formData.admission_date).toLocaleString() : 'N/A'}</span></div>
            <div class="data-item"><span class="label">Department:</span> <span class="value">${formData.department || 'N/A'}</span></div>
            <div class="data-item"><span class="label">Consulting Doctor:</span> <span class="value">${formData.consulting_doctor || 'N/A'}</span></div>
            <div class="data-item"><span class="label">Admission Type:</span> <span class="value">${formData.admission_type}</span></div>
            <div class="data-item"><span class="label">Ward / Room / Bed:</span> <span class="value">${formData.ward_type || 'N/A'} / ${formData.room_no || 'N/A'} / ${formData.bed_no || 'N/A'}</span></div>
            <div class="data-item full-width"><span class="label">Reason for Admission:</span> <span class="value">${formData.reason_for_admission || 'N/A'}</span></div>
          </div>

          <div class="section-header">3. Clinical Overview</div>
          <div class="data-grid">
            <div class="data-item"><span class="label">Primary Diagnosis:</span> <span class="value">${formData.primary_diagnosis || 'N/A'}</span></div>
            <div class="data-item"><span class="label">Secondary Diagnosis:</span> <span class="value">${formData.secondary_diagnosis || 'N/A'}</span></div>
            <div class="data-item full-width"><span class="label">Allergies:</span> <span class="value" style="color: red; font-weight: bold;">${formData.allergies || 'None Recorded'}</span></div>
          </div>

          <div class="section-header">4. Insurance Details</div>
          <div class="data-grid">
            <div class="data-item"><span class="label">Insurance Type:</span> <span class="value">${formData.insurance_type || 'Self-Pay / N/A'}</span></div>
            ${formData.insurance_type === "Private Cashless Insurance" ? `
              <div class="data-item"><span class="label">Insurance Company:</span> <span class="value">${formData.insurance_company || 'N/A'}</span></div>
              <div class="data-item"><span class="label">Policy Number:</span> <span class="value">${formData.policy_number || 'N/A'}</span></div>
              <div class="data-item"><span class="label">Expiry Date:</span> <span class="value">${formData.insurance_expiry_date ? formData.insurance_expiry_date.split('T')[0] : 'N/A'}</span></div>
              <div class="data-item"><span class="label">Approved Amount:</span> <span class="value">₹ ${parseFloat(formData.insurance_amount || 0).toFixed(2)}</span></div>
            ` : ''}
          </div>

          <div class="sig-box">
             <div class="sig">Patient / Guardian Signature</div>
             <div class="sig">Admitting Officer</div>
          </div>

          <div class="footer">
            System Generated Report - Emedha HMS
          </div>
        </body>
      </html>
    `;
    
    newWindow.document.write(htmlContent);
    newWindow.document.close();
  };

 




  // --- REUSABLE STYLES FOR COOL BUTTONS ---
  const addBtnStyle = { padding: '6px 14px', backgroundColor: '#3498db', color: '#fff', border: 'none', borderRadius: '20px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold', boxShadow: '0 2px 5px rgba(52, 152, 219, 0.3)', transition: 'all 0.2s ease', alignSelf: 'center' };
  const removeBtnStyle = { width: '28px', height: '28px', backgroundColor: '#ffebeb', color: '#e74c3c', border: '1px solid #f5c6c6', borderRadius: '50%', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s ease', marginLeft: 'auto' };

  return (
    <div className="registration-container fade-in">
      
      {(screenAction === "edit" || screenAction === "view") && (
        <div className="patient-search">
          <label>Search Admissions</label>
          <input type="text" value={searchText} placeholder="Search by Admission ID, Patient ID, Mobile..." onChange={(e) => searchAdmissions(e.target.value)} autoFocus />
          {showDropdown && admissions.length > 0 && (
            <div className="patient-dropdown">
              {admissions.map((adm) => (
                <div key={adm.admission_id} className="patient-item" onClick={() => selectAdmission(adm)}>
                  {adm.admission_id} | {adm.patient_name} | Ph: {adm.mobile}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <form className="luxury-form">
        
        {/* 1. PATIENT BASIC DETAILS */}
        <div className="form-section-header" ><h3>1. Patient Basic Details</h3></div>
        <div className="form-grid" style={getGridStyle(4)}>
<div className="input-box">
  <label>
    Patient ID / Name / Mobile <span style={{ color: "red" }}>*</span>
  </label>

  <input
    type="text"
    value={formData.patient_id}
    onChange={handlePatientSearch}
    placeholder="Search by ID, Name, Mobile..."
  />

  {suggestions.length > 0 && (
    <div className="dropdown">
      {suggestions.map((item, index) => (
        <div
          key={index}
          className="dropdown-item"
          onClick={() => handleSelectPatient(item)}
        >
          <strong>{item.patient_id}</strong> - {item.name} ({item.mobile})
        </div>
      ))}
    </div>
  )}
</div>
          <div className="input-box read-only"><label>Full Name</label><input type="text" value={formData.patient_name} readOnly /></div>
          <div className="input-box read-only"><label>Age / Gender</label><input type="text" value={`${formData.patient_details?.age || ''} / ${formData.patient_details?.gender || ''}`} readOnly /></div>
          <div className="input-box read-only"><label>Blood Group</label><input type="text" value={formData.patient_details?.blood_group || ''} readOnly /></div>
          <div className="input-box read-only"><label>Contact Number</label><input type="text" value={formData.patient_details?.mobile || ''} readOnly /></div>
          <div className="input-box read-only"><label>Emergency Contact</label><input type="text" value={`${formData.patient_details?.emergency_name || ''} - ${formData.patient_details?.emergency_phone || ''}`} readOnly /></div>
          <div className="input-box read-only"  style={getSpanStyle(2)}><label>Address</label><input type="text" value={formData.patient_details?.address || ''} readOnly /></div>
        </div>

        {/* 2. ADMISSION DETAILS */}
        <div className="form-section-header"><h3>2. Admission Details</h3></div>
        <div className="form-grid" style={getGridStyle(4)}>
          <div className="input-box read-only"><label>Admission ID</label><input type="text" value={formData.admission_id} readOnly /></div>
          <div className="input-box"><label>Admission Date & Time</label><input type="datetime-local" name="admission_date" value={formData.admission_date} onChange={handleChange} disabled={isDisabled} /></div>
           <div className="input-box"><label>Admission Type</label>
            <select name="admission_type" value={formData.admission_type} onChange={handleChange} disabled={isDisabled}>
              <option>Planned</option><option>Emergency</option><option>Transfer</option>
            </select>
          </div>
          <div className="input-box"><label>Department</label>
            <select name="department" value={formData.department} onChange={handleChange} disabled={isDisabled}>
              <option value="">Select Dept</option>
              {departments.map(d => <option key={d.dept_cd} value={d.dept_name}>{d.dept_name}</option>)}
            </select>
          </div>
          <div className="input-box"><label>Consulting Doctor</label>
            <select name="consulting_doctor" value={formData.consulting_doctor} onChange={handleChange} disabled={isDisabled}>
              <option value="">Select Doctor</option>
              {doctors.map(d => <option key={d.doc_cd} value={d.doctor_name}>{d.doctor_name}</option>)}
            </select>
          </div>
        
          <div className="input-box"><label>Referred By</label><input type="text" name="referred_by" value={formData.referred_by} onChange={handleChange} disabled={isDisabled} /></div>
          <div className="input-box" style={getSpanStyle(2)}><label>Reason for Admission</label><input type="text" name="reason_for_admission" value={formData.reason_for_admission} onChange={handleChange} disabled={isDisabled} /></div>
        </div>

        {/* 3. BED / WARD MANAGEMENT */}
        <div className="form-section-header"><h3>3. Bed / Ward Management</h3></div>
        <div className="form-grid" style={getGridStyle(5)}>
          <div className="input-box"><label>Assign Bed <span style={{color:'red'}}>*</span></label>
            <select name="bed_id" value={formData.bed_id} onChange={handleBedSelect} disabled={isDisabled}>
              <option value="">-- Available Beds --</option>
              {beds.filter(b => b.status === "Available" || b.bed_id === formData.bed_id).map(b => (
                <option key={b.bed_id} value={b.bed_id}>Room: {b.room_no} | Bed: {b.bed_no} ({b.room_type})</option>
              ))}
            </select>
          </div>
          <div className="input-box read-only"><label>Ward Type</label><input type="text" value={formData.ward_type} readOnly /></div>
          <div className="input-box read-only"><label>Room No.</label><input type="text" value={formData.room_no} readOnly /></div>
          <div className="input-box read-only"><label>Bed No.</label><input type="text" value={formData.bed_no} readOnly /></div>
          <div className="input-box read-only"><label>Bed Charges (Per Day)</label><input type="text" value={formData.bed_charges} readOnly /></div>
        </div>

        {/* 4. CLINICAL INFORMATION */}
        <div className="form-section-header"><h3>4. Clinical Information (Joining Time)</h3></div>
        <div className="form-grid" style={getGridStyle(4)}>
          <div className="input-box"><label>Primary Diagnosis</label><input type="text" name="primary_diagnosis" value={formData.primary_diagnosis} onChange={handleChange} disabled={isDisabled} /></div>
          <div className="input-box"><label>Secondary Diagnosis</label><input type="text" name="secondary_diagnosis" value={formData.secondary_diagnosis} onChange={handleChange} disabled={isDisabled} /></div>
          <div className="input-box" style={getSpanStyle(2)}><label>Symptoms</label><input type="text" name="symptoms" value={formData.symptoms} onChange={handleChange} disabled={isDisabled} /></div>
          <div className="input-box"><label>Medical History</label><input type="text" name="medical_history" value={formData.medical_history} onChange={handleChange} disabled={isDisabled} /></div>
          <div className="input-box"><label>Allergies <span style={{color:'red'}}>(CRITICAL)</span></label><input type="text" name="allergies" value={formData.allergies} onChange={handleChange} disabled={isDisabled} style={{border:'1px solid red'}}/></div>
          <div className="input-box" style={getSpanStyle(2)}><label>Treatment Plan</label><input type="text" name="treatment_plan" value={formData.treatment_plan} onChange={handleChange} disabled={isDisabled} /></div>
        </div>


        {/* 5. INSURANCE DETAILS */}
        <div className="form-section-header"><h3>5. Insurance Details</h3></div>
        
        <div className="form-grid" style={getGridStyle(5)}>
          <div className="input-box" style={{ maxWidth: "250px", width: "100%" }}>
            <label>Insurance Type</label>
            <select
              name="insurance_type"
              value={formData.insurance_type || ""}
              onChange={handleChange}
              disabled={isDisabled}
            >
              <option value="">Select Insurance Type</option>
              {insuranceTypes.map((item) => (
                <option
                  key={item.insurance_type_id}
                  value={item.insurance_type_name}
                >
                  {item.insurance_type_name}
                </option>
              ))}
            </select>
          </div>

          {/* Only show these fields if "Private Cashless Insurance" is selected */}
          {formData.insurance_type === "Private Cashless Insurance" && (
            <>
              <div className="input-box" style={{ maxWidth: "250px", width: "100%" }}>
                <label>Insurance Company</label>
                <input type="text" name="insurance_company" onChange={handleChange} value={formData.insurance_company || ""} disabled={isDisabled} placeholder="e.g. Star Health" />
              </div>

              <div className="input-box" style={{ maxWidth: "250px", width: "100%" }}>
                <label>Policy Number</label>
                <input type="text" name="policy_number" onChange={handleChange} value={formData.policy_number || ""} disabled={isDisabled} />
              </div>

              <div className="input-box" style={{ maxWidth: "250px", width: "100%" }}>
                <label>Expiry Date</label>
                <input type="date" name="insurance_expiry_date" onChange={handleChange} value={formData.insurance_expiry_date ? formData.insurance_expiry_date.split("T")[0] : ""} disabled={isDisabled} />
              </div>
              
              <div className="input-box" style={{ maxWidth: "250px", width: "100%" }}>
                <label>Insurance Amount (₹)</label>
                <input type="number" name="insurance_amount" onChange={handleChange} value={formData.insurance_amount || ""} disabled={isDisabled} placeholder="0.00" />
              </div>
            </>
          )}
        </div>

      </form>
    </div>
  );
};


export default InpatientManagement;